
  <div id="tabCambiarUsuario" class="centrado login">
    <div class="col-login">
      <div class="loginInputWrap" [formGroup]="codigoForm" style="margin-top: 65px;">
        <div class="tituloInt">{{ 'CODIGO_AUTENTICACION' | translate }}</div>
        <p *ngIf="error" style="color: red">{{ error }}</p>
          <label for="contrasena">{{'INTRODUCIRCODIGOCORREO'| translate}}</label> 
          <div class="form-group" style="align-items: center">
          <input
            formControlName="codigo"
            #clave
            category="pago"
            type="text"
            class="form-control"
            id="codigo"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(clave) }"
            (focus)="focusValue($event)"
          />
        </div> 
        <a class="GestionarButton aceptar" [ngClass]="{ disabled: checkLoginIsInvalid() }" (click)="hacerLogin()">
            {{ 'ACEPTAR' | translate }}
        </a>
        <a class="CancelButton" (click)="cancelar()" title="Cancelar">
            {{ 'CANCELAR' | translate }}
        </a>
      </div>
      <ng-template #loading class="DetalleBox__noResultsMessage">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </ng-template>
    </div>
  </div>
